import {
  ButtonConfig,
  ButtonSize,
  ButtonVariant,
} from '@/shared/styles/components/button/types';
import {
  buttonDimensions,
  buttonEffects,
  buttonTypography,
  baseButtonStyle,
  baseLabelStyle,
  buttonVariants,
} from './components/button/buttonStyles';
import { disabledGreen, disabledGrey } from '@/shared/styles/colors';

export const getButtonStyles = (
  variant: ButtonVariant,
  size: ButtonSize,
  isDesktop = false,
): ButtonConfig => {
  // Get configurations for each aspect of the button
  const variantConfig = buttonVariants[variant];
  const dimensionsConfig = buttonDimensions[size];
  const typographyConfig = buttonTypography[size];
  const effectsConfig = buttonEffects[size];

  // Calculate responsive values
  const height = isDesktop
    ? dimensionsConfig.height.desktop
    : dimensionsConfig.height.mobile;
  const maxWidth = isDesktop
    ? dimensionsConfig.maxWidth.desktop
    : dimensionsConfig.maxWidth.mobile;
  const fontSize = isDesktop
    ? typographyConfig.fontSize.desktop
    : typographyConfig.fontSize.mobile;

  return {
    dimensions: {
      maxWidth: dimensionsConfig.maxWidth,
      height: dimensionsConfig.height,
    },

    // Main button styling
    buttonStyle: [
      baseButtonStyle,
      {
        backgroundColor: variantConfig.backgroundColor,
        borderColor: variantConfig.borderColor,
        maxWidth,
        height,
        // Apply shadow effects if they exist
        ...(effectsConfig?.shadow || {}),
      },
    ],

    // Typography styling
    labelStyle: [
      baseLabelStyle,
      {
        color: variantConfig.labelColor,
        fontSize,
      },
    ],

    // Interactive state configurations
    hoverColor: variantConfig.hoverColor,
    hoverLabelColor: variantConfig.hoverLabelColor,
    hoverBorderColor: variantConfig.hoverBorderColor,

    // State-specific styles
    disabledStyle: {
      backgroundColor: disabledGrey,
      borderColor: disabledGrey,
    },
    disabledLabelStyle: {
      color: disabledGreen,
    },
    loadingLabelStyle: {
      fontSize: 30,
      marginLeft: 0,
    },

    // Effects configuration
    effects: effectsConfig,
  };
};
